import React, { useState } from 'react';
import { useTranslations } from '@storebrand-digital/fms-translations-react';
import { FieldProps, ObjectSchema, StringSchema, ArraySchema } from '../types';
import { TabbedContent } from './TabbedContent';
import { fallbackToRaw, getTextAndFormatWithFallback } from '../../utils/utils';
import Paper from '../../shared/components/Paper/Paper';

type ItemSchema = ObjectSchema<{
  title: StringSchema;
  valueList: ArraySchema<StringSchema>;
}>;

type TabbedInfoFieldProps = FieldProps<ArraySchema<ItemSchema>>;

export const TabbedInfoField = ({
  schema,
  value,
  extraFieldData
}: TabbedInfoFieldProps) => {
  const { getText } = useTranslations();

  const [selected, setSelected] = useState<number>(0);

  const content = value.map(({ title, valueList }, id) => ({
    title: getTextAndFormatWithFallback(
      title || `Tab ${id}`,
      extraFieldData || {},
      getText
    ),
    valueList: valueList.map(val =>
      getTextAndFormatWithFallback(val || '', extraFieldData || {}, getText)
    )
  }));

  return (
    <Paper dense withBackground>
      <TabbedContent
        title={schema.title && fallbackToRaw(schema.title, getText)}
        description={schema.description || ''}
        content={content}
        selected={selected}
        onChange={setSelected}
      />
    </Paper>
  );
};
